import _ from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DWTCContext } from '../utils/context';
import { Button } from './styles/Button.styled';

export default function DownloadSustainabilityReport({ data, id, dir }) {
  const title = _.get(data, 'downloadSustainabilityTitle', '');
  const date = _.get(data, 'downloadSustainabilityDate', '');
  const link = _.get(data, 'downloadSustainabilityButton', null);
  const image = _.get(data, 'downloadSustainabilityImage', null);
  const { cssClass } = React.useContext(DWTCContext);
  const [buttonTheme, setButtonTheme] = React.useState('');

  React.useEffect(() => {
    if (_.includes(cssClass, 'free-zone')) setButtonTheme('red');
    else if (_.includes(cssClass, 'real-estate')) setButtonTheme('green');
    else setButtonTheme('secondary');
  }, []);

  const columnBtn = link ? (
    <div className="cta-wrapper ltr:md:text-left rtl:md:text-right text-center">
      <Button
        stylevariant={buttonTheme}
        href={link.url}
        target={link.target}
        rel=""
        className=""
        dir={dir}>
        {link.name}
      </Button>
    </div>
  ) : null;
  return (
    <section id={id} className="bg-[#F7F7F7] overflow-hidden flex flex-col md:flex-row
    mb-[-30px] md:mb-[-50px]">
      <div
        className="md:w-1/2 pt-[50px] pb-8 md:py-[72px] flex flex-col justify-center
          rtl:md:pl-10 rtl:xl:pl-[229px] relative overflow-hidden
          md:items-end ltr:md:pr-10 ltr:xl:pr-[229px] items-center
          ">
        <div className="flex flex-col gap-6 md:gap-[50px] max-w-[371px] px-6 md:px-0">
          <div className="flex flex-col gap-2.5 md:gap-y-[15px]">
            <div
              className="text-[#4A4A4A] 
              ltr:font-LibreBaskervilleRegular 
              rtl:font-GEAwtarDWTCMedium text-clamp22to30
              ltr:md:text-left rtl:md:text-right text-center h2-child:!mb-0"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p
              className="text-[#4A4A4A] text-clamp12to15 font-medium leading-[133.33%]
              font-DINMedium !mb-0 ltr:md:text-left rtl:md:text-right text-center">
              {date}
            </p>
          </div>
          {columnBtn}
        </div>
      </div>
      <div className="md:w-1/2 min-h-full [&>span]:h-full relative overflow-hidden ">
        {_.isEmpty(image) || (
          <LazyLoadImage
            src={image.url}
            alt={title}
            className="w-full h-full object-cover relative z-30"
          />
        )}
      </div>
    </section>
  );
}
